module.exports = __webpack_public_path__ + "static/media/ChatbotLogo_HBT.35e92007.svg";